import moment, { Moment } from 'moment'
import { ChartView } from 'src/Libs/chart-kit'
import { Resolution, ResolutionTypes } from 'src/Libs/chart-kit/shared/types'
import { getHistoryChartTimePeriodBasedOnResolution } from 'src/Libs/chart-kit/shared/utils/csv-export-fns'
import { HistoryPayloadBasedOnView } from 'src/Libs/system-data-handler'
import { getMidnightToDateValue } from 'src/Libs/system-data-handler/utils/datetime'

interface ReturnType {
  payload: HistoryPayloadBasedOnView
}

/**
 * Get the history data date/view settings based on the view. This involves the payload for fetching different types of history data.
 */
export const getHistoryDataFetchSettings = (
  originalFrom: Moment,
  originalTo: Moment,
  view: ChartView,
  resolution?: Resolution,
  includeFirst?: boolean
): ReturnType => {
  const isToInTheFuture = moment(originalTo).isAfter(moment(), 'day')
  const viewToUse = resolution ? getHistoryChartTimePeriodBasedOnResolution(resolution) : view
  const isRawData = true

  /** These are cases where the backend deliver an extra entry we need to show in some cases */
  const isWeekWithDayResolutionOrFifteenMinutesResolution =
    (view === 'week' && resolution === ResolutionTypes.Day) || resolution === ResolutionTypes.FifteenMinutes
  const includeLast = isWeekWithDayResolutionOrFifteenMinutesResolution ? true : isToInTheFuture && (view === 'month' || view === 'year')

  const payload: HistoryPayloadBasedOnView = {
    from: originalFrom.valueOf(),
    to: getMidnightToDateValue(originalTo).valueOf(),
    view: viewToUse,
    includeFirst: includeFirst ?? false,
    includeLast,
    isRawData,
  }

  return { payload }
}
